import React from "react";
import { useTranslation } from "react-i18next";

export default function ConsultantSearchBar({

    filters,
    onChange,
    onSearch,
    total = 0

}) {

    /*=========================================================
        Hook i18next
    =========================================================*/

    const { t, i18n } = useTranslation();

   
    /*=========================================================
        Changement du mot clé
    =========================================================*/

    const handleChange = (event) => {

        onChange(
            event.target.name,
            event.target.value
        );

    };

    /*=========================================================
        Recherche avec la touche Entrée
    =========================================================*/

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            onSearch();
        }

    };

    /*=========================================================
        Affichage
    =========================================================*/

    return (

        <div className="consultant-search-header card shadow-sm border-0 mb-4">
            <div className="card-body p-4">
                {/*=================================================*/}
                {/* Titre */}
                {/*=================================================*/}

                <div className="mb-4">

                    <h2 className="fw-bold text-success">

                        {t("consultant.search.title")}

                    </h2>

                    <div className="text-muted">

                        {t("consultant.search.subtitle")}

                    </div>

                    <div className="mt-2">

                        <span className="badge bg-primary fs-6">

                            {t("consultant.search.result", {

                                count: total

                            })}

                        </span>

                    </div>

                </div>

                {/*=================================================*/}
                {/* Zone de recherche */}
                {/*=================================================*/}

                <div className="row g-3 align-items-end">

                    {/*=============================================*/}
                    {/* Mot clé */}
                    {/*=============================================*/}

                    <div className="col-lg-5">

                        <label className="form-label fw-semibold">

                            <i className="bi bi-search me-2"></i>

                            {t("consultant.search.keyword")}

                        </label>

                        <input

                            type="text"

                            className="form-control form-control-lg"

                            placeholder={t("consultant.search.placeholder")}

                            name="keyword"

                            value={filters.keyword || ""}

                            onChange={handleChange}

                            onKeyDown={handleKeyPress}

                        />

                    </div>

                    {/*=============================================*/}
                    {/* Bouton Rechercher */}
                    {/*=============================================*/}

                    <div className="col-lg-3 d-grid">

                        <button

                            type="button"

                            className="btn btn-success btn-lg"

                            onClick={onSearch}

                        >

                            <i className="bi bi-search me-2"></i>

                            {t("button.search")}

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}